import '../styles/timeline.css'
import React from 'react';

import TimelineEntry from './timeline-entry';


class TimelineComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      timelineEntries: props.timelineEntries || [],
    }
  }

  componentDidUpdate = (nextProps) => {
    if (this.state.timelineEntries !== this.props.timelineEntries)
      this.setState({ timelineEntries: this.props.timelineEntries });
  }


  extentToString = (extent) => {
    return `${extent[0].toFixed(2)},${extent[1].toFixed(2)} ${extent[2].toFixed(2)},${extent[3].toFixed(2)}`;
  }

  render = () => {

    let body = null;

    // If the user is zoomed out too far tell them to zoom in
    if (this.props.zoomIn) {
      body = (
        <p>
          Please zoom in to see timeline details of wildfires in the area.
        </p>
      );
    } else {
      // Otherwise map all the entries to a Timeline entry component

      let renderedChildren = this.state.timelineEntries.map((entry,idx) => { 
          
        if(this.props.highlightId === undefined || this.props.highlightId === false)
          return <TimelineEntry key={idx} entry={entry} onEntrySelected={this.props.onEntrySelected} onEntryDeselected={this.props.onEntryDeselected} highlighted={undefined}/>
        
        let highlighted = this.props.highlightId === (entry.id);
        return <TimelineEntry key={idx} entry={entry} onEntrySelected={this.props.onEntrySelected} onEntryDeselected={this.props.onEntryDeselected} highlighted={highlighted} />
      });

      body = (
        <div className="TimelineEntries">
          {renderedChildren}
        </div>
      );
    }

    return (
      <div className="TimelineContainer">
        <div className='TimelineContainerHeader'>
          <h2 className='Oswald uppercase gappyText'>Wildfire History Timeline</h2>
          <div className='controls'>
            { this.props.zoomIn ? null : ( <button className='printButton button primary no-print' onClick={this.props.onPrintClicked}>Print Report</button> )  }
          </div>
        </div>
        {body}
      </div>
    )
  }
}

export default TimelineComponent;